
import bootbox from 'bootbox';

function MusicPlaylist() {
    this.user_playlist = [];
    return this;
}


MusicPlaylist.prototype.init = function() {

    if ($('.playlist-success').length) {
        this.clearCollection();
        return;
    }

    this.bindControls();

    if (JSON.parse(localStorage.getItem('playlist')) === null) {
        localStorage.setItem('playlist', JSON.stringify([]));
    }

    this.getPlaylist();
    this.updateCollection();
};


MusicPlaylist.prototype.bindControls = function() {

    const self = this,
          $playlist = $('.playlist'),
          formPlaylistField = $('#PlaylistSubmitForm_Form_PlaylistItems');


    $playlist.on('click', '.playlist-clear-search', function(e){
        e.preventDefault();
        $('.playlist-filter-search').val('');
        $('.playlist-filter-search-submit').click();
    });

    $playlist.on('click', '.playlist-submit-btn', function(e){
        e.preventDefault();

        var listOfSpotifyIds = [];
        $('.playlist-collection-song').each(function () {
            var item = $(this);
            listOfSpotifyIds.push(item.attr('data-spotify-track-id'));
        });

        formPlaylistField.val(listOfSpotifyIds.toString());

        if(listOfSpotifyIds.length > 0){
            $('.playlist-submit-form').removeClass('d-none');
            $('.playlist-editor').addClass('d-none');
        }
    });

    $playlist.on('click', '.playlist-cancel-submit-btn', function(e){
        e.preventDefault();
        $('.playlist-editor').removeClass('d-none');
        $('.playlist-submit-form').addClass('d-none');
        formPlaylistField.val('');
    });

    $playlist.on('click', '.playlist-collection-toggle', function(e){
        e.preventDefault();
        const $html = $('html');
        $html.toggleClass('playlist-collection-open');
        if ($html.hasClass('playlist-collection-open')) {
            $(this).text('Close');
        } else {
            $(this).text('Open');
        }
    });

    $playlist.on('click', '.playlist-song-preview-play', function(e){
        e.preventDefault();
        const spotify_track_id = $(this).parents('.playlist-song').data('spotify-track-id');
        self.playPreview(spotify_track_id);
    });

    $playlist.on('click', '.playlist-song-preview-close', function(e){
        e.preventDefault();
        const spotify_track_id = $(this).parents('.playlist-song').data('spotify-track-id');
        self.closePreview(spotify_track_id);
    });

    $playlist.on('click', '.playlist-song-add', function(e){
        e.preventDefault();
        const spotify_track_id = $(this).parents('.playlist-song').data('spotify-track-id');
        self.addToCollection(spotify_track_id);
    });

    $playlist.on('click', '.playlist-collection-clear', function(e){
        e.preventDefault();
        bootbox.confirm({
            message: 'All songs will be removed from your playlist, are you sure you want to continue?',
            centerVertical: true,
            callback: result => {
                if (result) self.clearCollection();
            }
        });
    });

    $playlist.on('click', '.playlist-collection-song-remove', function(e){
        e.preventDefault();
        const spotify_track_id = $(this).parents('.playlist-collection-song').data('spotify-track-id');
        bootbox.confirm({
            message: 'Are you sure you want to remove this song from your playlist?',
            centerVertical: true,
            callback: result => {
                if (result) self.removeFromCollection(spotify_track_id);
            }
        });
    });

    $playlist.on('change', '.playlist-filter-sort', function(e){
        e.preventDefault();
        self.filterPlaylist('sort');
    });

    $playlist.on('click', '.playlist-filter-search-submit', function(e) {
        e.preventDefault();
        self.filterPlaylist('search');
    });

    $playlist.on('click', '.playlist-pagination .page-link', function(e) {
        e.preventDefault();
        self.changePlaylistPage(this);
    });

    $playlist.find('#PlaylistSubmitForm_Form').off('submit').on('submit', function(e){
        const $button = $('#PlaylistForm_Form_action_submit');
        const formValid = $(this)[0].checkValidity();

        if (!recaptchaComplete && formValid) {
            grecaptcha.execute();
            $(this).addClass('was-validated');
        }

        if (!recaptchaComplete || formValid === false) {
            e.preventDefault();
            grecaptcha.execute();
            $(this).addClass('was-validated');
        }

        if (recaptchaComplete && formValid) {
            $button.data('original-text', $button.html());
            $button.width($button.width());
            $button.attr('disabled', true);
            $button.html('<i class="fas fa-circle-notch fa-spin"></i>');
        }

    });


};


MusicPlaylist.prototype.changePlaylistPage = function(element) {

    const self = this,
        $this = $(element),
        $playlist_songs = $('.playlist-songs'),
        url = $this.attr('href');

    $.ajax({
        url,
        beforeSend: function(){
            $this.data('original-text', $this.html());
            $this.width($this.width());
            $this.attr('disabled', true);
            $this.html('<i class="fas fa-circle-notch fa-spin"></i>');
        },
        success: function(data){
            const html = $(data).find('.playlist-songs').html();
            $playlist_songs.html(html);
            history.pushState(null, null, url);
        }
    }).always(function() {
        $this.html($this.data('original-text'));
        $this.attr('disabled', false);
        $('html, body').animate({
            scrollTop: $('.playlist').offset().top
        }, 500);
        self.updateCollection();
    });

};


MusicPlaylist.prototype.filterPlaylist = function(origin) {

    const $playlist_songs = $('.playlist-songs'),
        $search_input = $('.playlist-filter-search'),
        $search_button = $('.playlist-filter-search-submit'),
        $search_term_display = $('.playlist-search-term-display'),
        sort_term = $('.playlist-filter-sort').val(),
        search_term = $search_input.val(),
        search_name = $search_input.attr('name');

    let url = search_term !== '' ? `${location.pathname}?${search_name}=${search_term}` : location.pathname;

    if (sort_term !== '') url += url.indexOf('?') !== -1 ? `&sort=${sort_term}` : `?sort=${sort_term}`;

    $.ajax({
        url,
        beforeSend: function(){
            if (origin === 'search') {
                $search_button.data('original-text', $search_button.html());
                $search_button.width($search_button.width());
                $search_button.attr('disabled', true);
                $search_button.html('<i class="fas fa-circle-notch fa-spin"></i>');
            }
        },
        success: function(data){
            const html = $(data).find('.playlist-songs').html();
            $playlist_songs.html(html);
            history.pushState(null, null, url);
        }
    }).always(function() {
        if (origin === 'search') {
            $search_term_display.find('.playlist-search-term').text($search_input.val());
            $search_input.val() === '' ? $search_term_display.addClass('d-none') : $search_term_display.removeClass('d-none');
            $search_button.html($search_button.data('original-text'));
            $search_button.attr('disabled', false);
        }
    });

};


MusicPlaylist.prototype.addToCollection = function(spotify_track_id) {
    const $song = $(`.playlist-song[data-spotify-track-id="${spotify_track_id}"]`);

    const song_data = {
        track_id: $song.data('track-id'),
        spotify_track_id,
        title: $song.data('title'),
        artwork_url: $song.data('artwork-url'),
        artist: $song.data('artist'),
        album: $song.data('album'),
        duration: $song.data('duration'),
        release_date: $song.data('release-date')
    };

    if (this.user_playlist.findIndex(song => song.track_id === song_data.track_id) === -1) {
        this.user_playlist.push(song_data);
    }

    this.setPlaylist();
    this.updateCollection();
};


MusicPlaylist.prototype.removeFromCollection = function(spotify_track_id) {
    const pos = this.user_playlist.findIndex(song => song.spotify_track_id === spotify_track_id);

    if (pos > -1) {
        this.user_playlist.splice(pos, 1);
    }

    this.setPlaylist();
    this.updateCollection();
};


MusicPlaylist.prototype.clearCollection = function() {
    this.user_playlist = [];
    this.setPlaylist();
    console.log('clear collection...');

    this.updateCollection();
};


MusicPlaylist.prototype.updateCollection = function() {

    const $collection_songs = $('.playlist-collection-songs');
    const $collection_empty = $('.playlist-collection-empty');
    const $collection_clear_btn = $('.playlist-collection-clear');
    const $collection_count = $('.playlist-collection-count');
    const $submit_playlist_button = $('.playlist-submit-btn');

    $('.playlist-song-add').html('<i class="fas fa-plus"></i><span class="d-none d-md-inline"> Add</span>').attr('disabled', false);

    if (!this.user_playlist.length) {
        $collection_songs.addClass('d-none');
        $collection_clear_btn.addClass('d-none');
        $collection_empty.removeClass('d-none');
        $collection_count.html('(0 songs)');
        $submit_playlist_button.addClass('disabled');
        $submit_playlist_button.attr('disabled','disabled');
        return;
    }

    $collection_clear_btn.removeClass('d-none');

    const collection_html = this.user_playlist.map(song => {
        $(`.playlist-song[data-spotify-track-id="${song.spotify_track_id}"]`).find('.playlist-song-add').html('<i class="fas fa-check"></i><span class="d-none d-md-inline"> Added</span>').attr('disabled', true);
        return this.collectionSongTemplate(song.spotify_track_id, song.artwork_url, song.title, song.artist);
    }).join('');

    $collection_songs.html(collection_html).removeClass('d-none');
    $collection_count.html(`(${this.user_playlist.length} song${this.user_playlist.length === 1 ? '' : 's'})`);
    $collection_empty.addClass('d-none');
    $submit_playlist_button.removeClass('disabled');
    $submit_playlist_button.removeAttr('disabled');
};


MusicPlaylist.prototype.setPlaylist = function() {
    localStorage.setItem('playlist', JSON.stringify(this.user_playlist));
};


MusicPlaylist.prototype.getPlaylist = function() {
    this.user_playlist = JSON.parse(localStorage.getItem('playlist'));
    return this.user_playlist;
};


MusicPlaylist.prototype.playPreview = function(spotify_track_id) {
    const $song = $(`.playlist-song[data-spotify-track-id="${spotify_track_id}"]`);
    const $song_preview = $song.find('.playlist-song-preview');
    const $song_preview_play = $song.find('.playlist-song-preview-play');
    const $song_preview_close = $song.find('.playlist-song-preview-close');

    // Close all previews
    $('.playlist-song-preview').html('').addClass('d-none');
    $('.playlist-song-preview-play').removeClass('d-none');
    $('.playlist-song-preview-close').addClass('d-none');

    $song_preview.html(`<iframe src="https://open.spotify.com/embed/track/${spotify_track_id}" width="100%" height="80" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe>`).removeClass('d-none');
    $song_preview_play.addClass('d-none');
    $song_preview_close.removeClass('d-none');
};


MusicPlaylist.prototype.closePreview = function(spotify_track_id) {
    const $song = $(`.playlist-song[data-spotify-track-id="${spotify_track_id}"]`);
    const $song_preview = $song.find('.playlist-song-preview');
    const $song_preview_play = $song.find('.playlist-song-preview-play');
    const $song_preview_close = $song.find('.playlist-song-preview-close');

    $song_preview.html('').addClass('d-none');
    $song_preview_play.removeClass('d-none');
    $song_preview_close.addClass('d-none');
};


MusicPlaylist.prototype.collectionSongTemplate = function(spotify_track_id, artwork_url, title, artist) {
    return `
         <div class="playlist-collection-song" data-spotify-track-id="${spotify_track_id}">
            <div class="playlist-collection-song-artwork-holder">
                <div class="playlist-collection-song-artwork" style="background-image:url('${artwork_url}');"></div>
            </div>

            <div class="playlist-collection-song-details">
                <div class="playlist-collection-song-title">
                    ${title}
                </div>
                <div class="playlist-collection-song-artist">
                    ${artist}
                </div>
            </div>

            <div class="playlist-collection-song-controls">
                <button class="btn btn-sm btn-outline-danger playlist-collection-song-remove"><i class="fas fa-trash"></i></button>
            </div>
         </div>
    `;
};


module.exports = MusicPlaylist;
